module.exports = __webpack_public_path__ + "static/media/e_3.7f3564e4.svg";